export function shuffleArray(array) {
  if (!array?.length) {
    return array;
  }
  return array
    .map(value => ({ value, _sort: Math.random() }))
    .sort((a, b) => a._sort - b._sort)
    .map(({ value }) => value)
}